import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useAuth } from "../../context/AuthContext";
import LoadingSpinner from "../ui/LoadingSpinner/LoadingSpinner";

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're not loading and there's no user
    if (!isLoading && !user) {
      navigate("/dashboard", { state: { from: location } });
    }
  }, [user, isLoading, navigate, location]);

  // Show loading spinner while authentication is being checked
  if (isLoading) {
    return (
      <LoadingSpinner />
    );
  }

  // Don't render anything if user is not authenticated (will redirect)
  if (!user) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
